import { REQUEST } from 'utils/actionGenerator';
import {takeLatest } from 'redux-saga/effects';
import * as api from './api';
import { fetchEntitySpawn } from 'store/saga';
import * as supplyTabActions from './actions';

export function* getSupplyDetails(params) {
  const request = api.getSupplyDetailsRequest(params);
  yield fetchEntitySpawn(request, supplyTabActions.getSupplyDetails, params);
}

export function* getOperatorSearchResults(params) {
  const request = api.getOperatorSearchResultsRequest(params);
  yield fetchEntitySpawn(request, supplyTabActions.getOperatorSearchResults, params);
}
export function* updateFreightDetails(action) {
  const { demandId, payload } = action.payload;
  const request = api.updateFreightDetailsRequest(demandId, payload);
  yield fetchEntitySpawn(request, supplyTabActions.updateFreightDetails, {
    toaster: { successMsg: 'Freight details updated succesfully', errorMsg: '' },
    payload,
  });
}

export function* createConsignmenet(action) {
  const request = api.createConsignmenetRequest(action.payload);
  yield fetchEntitySpawn(request, supplyTabActions.createConsignmenet, {
    toaster: { successMsg: 'Consignment created succesfully', errorMsg: '' },
    action,
  });
}

export function* updateConsignment(action) {
  const { consignmentId, payload } = action.payload;
  const request = api.updateConsignmentRequest(consignmentId, payload);
  yield fetchEntitySpawn(request, supplyTabActions.updateConsignment, {
    toaster: { successMsg: 'Consignment updated succesfully', errorMsg: '' },
    payload,
  });
}

export function* watchGetPhoneNoSaga(action) {
  const request = api.getPhoneNo(action.params);
  yield fetchEntitySpawn(request, supplyTabActions.getPhoneNo,null);
}
/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

function* mySaga() {
  yield takeLatest(supplyTabActions.GET_SUPPLY_DETAILS[REQUEST], getSupplyDetails);
  yield takeLatest(supplyTabActions.SEARCH_OPERATOR[REQUEST], getOperatorSearchResults);
  yield takeLatest(supplyTabActions.UPDATE_FREIGHT_DETAILS[REQUEST], updateFreightDetails);
  yield takeLatest(supplyTabActions.CREATE_CONSIGNMENT[REQUEST], createConsignmenet);
  yield takeLatest(supplyTabActions.UPDATE_CONSIGNMENT[REQUEST], updateConsignment);
  yield takeLatest(supplyTabActions.GET_PHONE_NO[REQUEST], watchGetPhoneNoSaga);
}

export default mySaga;
